import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer';
import {
  OnboardingStep,
  ONBOARDING_STEPS_ORDER,
} from '@/views/content-studio/onboarding/onboardingSteps';
import {FeatureId} from '../constants';

export type OnboardingWizardState = {
  step: OnboardingStep;
  previousSteps: OnboardingStep[];
  hoveredFeature: FeatureId | null;
  consentFormAccepted: boolean;
  selectedFeature: FeatureId | null;
};

const onboardingWizardStore = create<OnboardingWizardState>()(
  immer((_) => ({
    step: ONBOARDING_STEPS_ORDER[0],
    previousSteps: [],
    hoveredFeature: null,
    consentFormAccepted: false,
    selectedFeature: null,
  }))
);

const setStep = (step: OnboardingStep) => {
  onboardingWizardStore.setState((draft) => {
    draft.previousSteps.push(draft.step);
    draft.step = step;
  });
};

const goToPreviousStep = () => {
  onboardingWizardStore.setState((draft) => {
    if (draft.previousSteps.length > 0) {
      const previousStep = draft.previousSteps.pop();
      if (!previousStep) {
        return;
      }
      draft.step = previousStep;
    }
  });
};

const setSelectedFeature = (feature: FeatureId) => {
  onboardingWizardStore.setState((draft) => {
    draft.selectedFeature = feature;
  });
};

const setHoveredFeature = (feature: FeatureId | null) => {
  onboardingWizardStore.setState((draft) => {
    draft.hoveredFeature = feature;
  });
};

const setConsentFormAccepted = (isAccepted: boolean) => {
  onboardingWizardStore.setState((draft) => {
    draft.consentFormAccepted = isAccepted;
  });
};

export const onboardingWizardActions = {
  setStep,
  goToPreviousStep,
  setSelectedFeature,
  setHoveredFeature,
  setConsentFormAccepted,
};

export default onboardingWizardStore;
